import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { ButtonClose } from './ButtonClose.js';
import { Icon } from './Icon.js';

function getTypeCss(type) {
    switch (type) {
        case 'positive':
            return 'bg-green-100';
        case 'negative':
            return 'bg-red-300';
        case 'danger':
            return 'bg-yellow-100';
        default:
            return 'bg-white';
    }
}
const ModalPortal = ({ children }) => {
    const [el, setElement] = useState(null);
    useEffect(() => {
        const id = 'leafwell-modal-container';
        let element = document.getElementById(id);
        if (!element) {
            element = document.createElement('div');
            element.setAttribute('id', id);
            document.getElementById('leafwell-container').appendChild(element);
        }
        setElement(element);
    }, []);
    if (!el || !children) {
        return null;
    }
    return createPortal(children, el);
};
const Modal = ({ animate = true, children, closeLabel = 'Close', hasIcon = true, id, onClose = () => null, open = true, showClose = true, type = 'info', className, ...props }) => {
    const [visible, setVisible] = useState(open);
    const closeModal = () => {
        setVisible(false);
        onClose(id);
    };
    useEffect(() => {
        if (open) {
            setVisible(open);
        }
        else {
            closeModal();
        }
    }, [open]);
    return visible ? (React.createElement(ModalPortal, null,
        React.createElement("div", { className: "fixed z-40 left-0 top-0 p-4 w-full h-full grid items-center justify-items-center bg-gray-900 bg-opacity-50" },
            React.createElement("section", { className: [
                    'shadow-lg',
                    'w-full max-h-full',
                    'px-6',
                    'rounded-2xl',
                    'max-w-lg',
                    'overflow-auto',
                    animate ? 'animate-fade-in' : '',
                    className,
                    getTypeCss(type),
                ].join(' '), ...props },
                React.createElement("div", { className: ['grid', 'gap-4', 'py-6'].join(' ') },
                    showClose && (React.createElement(ButtonClose, { onClick: closeModal, label: closeLabel, className: "justify-self-end" })),
                    hasIcon && (React.createElement(Icon, { filled: false, type: type, className: "w-14 justify-self-center" })),
                    children))))) : null;
};

export { Modal };
//# sourceMappingURL=Modal.js.map
